<div class="db-advanced-tools">

  <div class="containers-wrap">
    <form [formGroup]="advancedTools">
      <div class="db-advanced-tools-block db-panel_flex">
      <div class="db-panel__header">Search and Replace Strings</div>
        <div class="db-panel__body">
          <div>
            <div class="db-advanced-tools-block-item">
              <div>Search String</div>
              <input type="text" formControlName="searchString" class="db-fc-input">
            </div>
            <div class="db-advanced-tools-block-item basic-info">
              <div>Replace String</div>
              <input type="text" formControlName="replaceString" class="db-fc-input">
            </div>
          </div>
          <a class="db-button db-button_info" (click)="replaceUrl()"><span>Submit</span></a>
        </div>
    </div>
    </form>

  </div>

  <db-loading-screen [ngClass]="{'hidden':!loading}" [pageBlocker]="false" [loadingMessage]=""></db-loading-screen>
</div>
